module.exports = __webpack_public_path__ + "images/delete-trash-black-3437987f.svg";